'use client';

import { useEffect, useMemo, useRef, type DependencyList } from 'react';

import { usePageActionsSlotContext, type MobileDetailTopBarConfig } from './PageActionsSlot';

export const useMobileDetailTopBar = (factory: () => MobileDetailTopBarConfig | null, deps: DependencyList): void => {
  const { registerMobileDetail, unregisterMobileDetail } = usePageActionsSlotContext();
  const idRef = useRef<symbol | null>(null);
  if (idRef.current === null) {
    idRef.current = Symbol('mobileDetailTopBar');
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const config = useMemo(factory, deps);

  useEffect(() => {
    const id = idRef.current!;
    registerMobileDetail(id, config);
  }, [config, registerMobileDetail]);

  useEffect(() => {
    const id = idRef.current!;
    return () => {
      unregisterMobileDetail(id);
    };
  }, [unregisterMobileDetail]);
};
